import { InviteePersonalData } from '../models/invitee';
import { getExternalUserUniqueId } from './getExternalUserUniqueId';

export type GroupTranscribeUserKeyInput =
  | { userId: string; customerId: string }
  | Pick<InviteePersonalData, 'firstName' | 'lastName' | 'email'>;

/**
 * Groups transcribe users by creating a unique key.
 * If userId and customerId are provided, uses: userId + customerId
 * Otherwise, uses: firstName-lastName-email
 */
export function groupTranscribeUserKey(
  input: GroupTranscribeUserKeyInput,
): string {
  if ('userId' in input && 'customerId' in input) {
    return input.userId + input.customerId;
  } else {
    return getExternalUserUniqueId({
      firstName: input.firstName,
      lastName: input.lastName,
      email: input.email,
    });
  }
}
